export const CLOTHING_SIZE_MAP: Record<string, string> = {
  xxs: '2S',
  small: 'S',
  medium: 'M',
  large: 'L',
  xl: 'XL',
  xxl: '2XL',
  xxxl: '3XL',
  '4xl': '4XL',
  '5xl': '5XL',
  'medium/large': 'M/L',
  'one size': 'One Size',
  'free-size': 'Free Size',
};

export const formatSize = (size: string): string => {
  const normalizedSize = size?.toLowerCase()?.trim();

  if (CLOTHING_SIZE_MAP[normalizedSize]) {
    return CLOTHING_SIZE_MAP[normalizedSize];
  }

  if (/^\d+$/?.test(size)) {
    return size;
  }
  if (/^[xX]/.test(size)) {
    return size?.toUpperCase(); // If it starts with 'x' or 'X', convert to uppercase
  }
  if (/^[a-zA-Z]+$/?.test(size)) {
    return size?.charAt(0)?.toUpperCase() + size?.slice(1)?.toLowerCase(); // Capitalize first letter if it's fully alphabets
  }
  return size; // Return as is for mixed text, numbers, or symbols (like '9-5 years')
};
